const getPosts = (url, numPosts) => {
  fetch(url)
    .then(response => response.json())
    .then(data => {
      const posts = data.slice(0, numPosts);
      displayPosts(posts);
      if (posts.length < numPosts) {
        const remainingPosts = numPosts - posts.length;
        const searchUrl = `https://column.second-hand.jp/wp-json/wp/v2/posts?_embed&categories=1&search=${encodeURIComponent('iphone xs')}`;
        fetch(searchUrl)
          .then(response => response.json())
          .then(searchData => {
            const additionalPosts = getUniquePosts(searchData, posts, remainingPosts);
            displayPosts(additionalPosts);
          })
          .catch(err => {
            console.log('Error: ' + err);
          });
      }
    })
    .catch(err => {
      console.log('Error: ' + err);
    });
};

const getUniquePosts = (searchData, existingPosts, numPosts) => {
  const uniquePosts = [];
  for (let i = 0; i < searchData.length; i++) {
    const searchPost = searchData[i];
    if (!existingPosts.some(existingPost => existingPost.id === searchPost.id) && !uniquePosts.some(uniquePost => uniquePost.id === searchPost.id)) {
      uniquePosts.push(searchPost);
    }
    if (uniquePosts.length === numPosts) {
      break;
    }
  }
  return uniquePosts;
};

const displayPosts = (posts) => {
  const viewPosts = document.getElementById('viewPosts');
  posts.forEach(post => {
    var date2 = new Date(post.date);
    var year = date2.getFullYear();
    var month = date2.getMonth() + 1;
    var day = date2.getDate();
    viewPosts.innerHTML += '<li class="posts">'
      + '<a href="' + post.link + '" class="linkID_' + post.id + '">'
      + '<img loading="lazy" src="' + post._embedded["wp:featuredmedia"][0].source_url + '" alt="' + post.title.rendered + '">'
      + '<time class="postTime dfont" itemprop="datePublished" datetime="' + post.date + '">' + year + '年' + month + '月' + day + '日' + '</time>'
      + '<p class="postTitle">' + post.title.rendered + '</p>'
      + '</a>'
      + '</li>';
  });
};

const url = "https://column.second-hand.jp/wp-json/wp/v2/posts?_embed&tags=110";
const numPosts = 6;
getPosts(url, numPosts);
